<template>
  <div class="item level">
    <div class="level-left shrink">
      <svgicon
        class="vue-icon level-item"
        :class="{ top: labelTop }"
        :name="imgName" width="20" height="20"></svgicon>
      <p class="level-item" :class="{ top: labelTop }">{{ name }}:</p>
      <div class="level-item shrink">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailItem',
  components: { },
  props: {
    name: String,
    imgName: String,
    value: [String, Number],
    labelTop: {
      type: Boolean,
      default: false,
    },
  },
  computed: { },
};
</script>

<style lang="scss" scoped>

.top {
  align-self: flex-start;
}

.item {
  background: $form-subitem;
  font-size: .9rem;
  margin-bottom: 0;
  padding: .25rem $content-padding;
  border-bottom: 1px solid $border-color;
  p {
    min-width: 175px;
    justify-content: left;
  }
  .shrink {
    flex-shrink: 1;  // This is necessary to get items to word wrap
    word-break: break-all;
  }
}
</style>
